import React from "react";

let warnings: Record<string, boolean> = {};

export const resetWarnings = () => {
  warnings = {};
};

export const useWarning = () => {
  return React.useMemo(() => {
    const warn = (warning: string) => {
      if (!warnings[warning] && process.env.NODE_ENV !== "production") {
        warnings[warning] = true;
        // eslint-disable-next-line no-console
        console.warn(warning);
      }
    };

    return {
      warn,
      warnDeprecation: warn
    };
  }, []);
};
